<template>
  <div class="bless-package">
    <!-- <transition name="bless"> -->
    <div class="not-open-status" v-show="isShowBless">
      <div class="preview-package">
        <img src="../images/yj_recall_fu.png" />
      </div>
      <p class="tip">送你一个福袋，打开有好礼</p>
      <p class="open-now" @click.stop="openBlessPackage">
        <img src="../images/yj_open_now.png" />
      </p>
    </div>
    <!-- </transition> -->
    <!-- <transition name="reward"> -->
    <div class="bless-bottom" v-if="!isShowBless">
      <!-- 获得的奖励/未命中图片 -->
      <div class="bless-img">
        <had-receive-reward
          v-if="showHadReceiveReward"
          :rewardData="rewardData"
          :receivePhone="receivePhone"
        ></had-receive-reward>
        <!-- 多奖励 -->
        <bless-rewards
          :code="resCode"
          :rewardData="rewardData"
          v-else-if="showBlessRewards"
        >
        </bless-rewards>
        <!-- 单个奖励 -->
        <bless-reward
          :code="resCode"
          :rewardData="rewardData"
          :receivePhone="receivePhone"
          :virtualCoinActivity="virtualCoinActivity"
          :showWeappTag="showWeappTag"
          :weappPath="weappPath"
          :getWxAppId="getWxAppId"
          @SHOW_MINIPROGRAM_CODE_IMAGE="toSee"
          v-else
        >
        </bless-reward>
      </div>
      <!-- 积分兑换优惠券 -->
      <!-- <coupon v-if="showCoupon" /> -->
      <!-- 推荐商品列表 -->
      <yj-list
        v-model="loading"
        :finished="finished"
        error-text="请求失败，点击重新加载"
        @load="onLoad"
        >
        <item-list v-if="itemList1.length > 0" :itemList1="itemList1" :itemList2="itemList2" :labelList1="labelList1" :labelList2="labelList2"> </item-list>
      </yj-list>
      

      <div class="to-see" @click="toSee">
        <img class="to-see-bg" src="../images/yj_prize_btn_bg.png" />
        <div class="to-see-btn">
          <span
            >{{ bottomButtonText }}<img src="../images/arrow_btn.png"
          /></span>
        </div>
      </div>
      <!-- 收下奖励->跳转app -->
      <!-- <div class="to-see to-app" @click="toSee">
        </div> -->
      <!-- 收下奖励->跳转小程序 -->
      <div class="to-see to-weapp" v-if="showWeappTag">
        <wx-open-launch-weapp
          class="wx-open-launch-weapp"
          :username="getWxAppId"
          :path="weappPath"
          @launch="handleLaunchFn"
          @error="handleErrorFn"
          @click="handleClickFn"
        >
          <script type="text/wxtag-template">
            <style>.btn { opacity: 0; width: 350px; height: 100px; display: block;border-radius: 0px;}</style>
            <button class="btn">打开小程序</button>
          </script>
        </wx-open-launch-weapp>
      </div>
    </div>
    <!-- </transition> -->

    <!-- 自己点击自己的分享弹窗 -->
    <share-alert
      :showShareAlert.sync="showShareAlert"
      :guideType="shareGuideType"
    ></share-alert>
    <!-- 小程序二维码 -->
    <applet-qrcode
      :showApplet.sync="showApplet"
      :qrcodeImage="qrcodeImage"
    ></applet-qrcode>
    <!-- 合技分享出来，展示我要送福袋 -->
    <div
      class="float-share"
      v-if="showShareBtn"
      @click.stop="showShareBlessGuide"
    >
      <img src="../images/yj_send_bless_float.gif" />
    </div>
    

    <guideDownloadApp @CLOSE_GUIDE_DOWNLOAD_APP_DIALOG="closeGuideDownloadAppDialog" :dialogShow="guideDownloadDialogShow"></guideDownloadApp>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { Toast, Indicator } from 'mint-ui'
import Vue from 'vue'
import { 
  List
} from '@yunji/h5'
import wxConstData from '@/common/define/wxConstData'
import {
  receiveReward,
  getSwich,
  queryRelationActivitySecondSharingSwitch,
  getIntelligentItemList,
  intelligentItem,
  getMiniProgramQrCode,
  getMoreBuyBanal,
  remarkReward,
  queryItemListMarks
} from '../api/home'
import blessReward from './blessReward'
import blessRewards from './blessRewards'
import hadReceiveReward from './hadReceiveReward'
import itemList from './itemList'
import moreBuyMoreReward from './moreBuyMoreReward'
import guideDownloadApp from './popup/guideDownloadApp.vue'
import coupon from './coupon'
import bus from '../js/bus'
import fuliImage from '../images/yj_more_fuli.png'
import toSeeImage from '../images/yj_app_to_see.png'
import lookRewardImage from '../images/yj_wx_to_see.png'
import exchangeInApp from '../images/yj_exchange_in_app.png'
import virtualCoinToSee from '../images/yj_virtual_coin_to_see.png'
import { VIP_CALL_ERROR_CODE_ENUM } from '../../../common/define/errorCodeEnum'
import { isTestEnv } from '../../../common/utils/commonUtil.js'
import {
  wxOpenLaunchWeappTagIsValid,
  getWxAppOriginId,
  forwardTo
} from '../../../common/utils/wxUtil.js'
import { createTicketByMj } from '@/common/js/fingerprintDevice'
import YunJi from '@/common/js/YunJi.js'
import { isWxProgram, exposureThinkingReport } from '../../../common/js/Util'

Vue.use(List)
/**
 * 奖励类型
 */
const REWARD_TYPE_ENUM = {
  /**
   * 积分
   */
  SCORE: 0,
  /**
   * 优惠券
   */
  COUPON: 1,
  /**
   * 云币
   */
  COIN: 2,
  /**
   * 虚拟云币
   */
  VIRTUAL_COIN: 3
}
/**
 * 已获得奖励类别
 */
const REWARD_CATEGORY = {
  /**
   * 积分
   */
  SCORE: 0,
  /**
   * 优惠券
   */
  COUPON: 1,
  /**
   * 云币
   */
  COIN: 2,
  /**
   * 虚拟云币
   */
  VIRTUAL_COIN: 3,
  /**
   * 组合奖励
   */
  COMBINE_PRIZE: 4
}
/**
 * 跳转按钮状态枚举
 */
const JUMP_TYPE = {
  /**
   * app
   */
  APP: 1,
  /**
   * 小程序
   */
  MINIPROGRAM: 2,
  /**
   * 专题
   */
  SUBJECT: 3,
  /**
   * h5
   */
  H5: 4
}

export default {
  name: 'blessPackage',
  data() {
    return {
      guideDownloadDialogShow: false,
      isShowBless: true,
      rewardData: {},
      isShowGuide: false,
      // 福袋分享按钮开关
      isShowShareBtn: false,
      swichTag: 1,
      // 推荐商品列表
      itemList1: [],
      // 推荐商品列表
      itemList2: [],
      // 展示分享弹窗
      showShareAlert: false,
      resCode: VIP_CALL_ERROR_CODE_ENUM.SUCCESS,
      // 小程序二维码
      showApplet: false,
      shareGuideType: 1,
      // 小程序二维码
      qrcodeImage: null,

      // 奖励接受者手机号
      receivePhone: '',
      // 设备指纹服务凭证
      tick: '',
      // 虚拟云币活动信息
      virtualCoinActivity: {
        exchangeTime: '', // 兑换时间
        subjectId: '' // 专题ID
      },
      labelList1: [],
      labelList2: [],
      isEmpty: false,
      loading: false,
      finished: true,
      pageIndex: 0
    }
  },
  props: {
    hasPhone: {
      type: Boolean,
      default: false
    },
    needLogin: {
      type: Boolean,
      default: false
    },
    bagBasicInfor: {
      type: Object,
      default: {}
    }
  },
  computed: {
    ...mapGetters([
      'appCont',
      'shopId',
      'isFromHeJi',
      'activityId',
      'luckBagCode',
      'smsId'
    ]),
    /**
     * 显示“福袋分享”按钮
     */
    showShareBtn() {
      return !this.isShowBless && this.isFromHeJi && this.isShowShareBtn
    },
    /**
     * 底部按钮文案
     */
    bottomButtonText() {
      let text = ''
      const bagBasicInfor = this.bagBasicInfor || {}
      if (this.resCode === VIP_CALL_ERROR_CODE_ENUM.SUCCESS) {
        switch (this.rewardCategory) {
          case REWARD_CATEGORY.SCORE:
            text = bagBasicInfor.scoreButtonText
            break
          case REWARD_CATEGORY.COUPON:
            text = bagBasicInfor.couponButtonText
            break
          case REWARD_CATEGORY.COIN:
            text = bagBasicInfor.coinButtonText
            break
          case REWARD_CATEGORY.VIRTUAL_COIN:
            text = bagBasicInfor.coinVirtualButtonText
            break
          case REWARD_CATEGORY.COMBINE_PRIZE:
            text = bagBasicInfor.combineButtonText
            break
        }
      } else if (
        this.resCode === VIP_CALL_ERROR_CODE_ENUM.RELATION_HAD_RECEIVE
      ) {
        text = bagBasicInfor.showButtonText
      } else {
        text = '更多奖励，尽在云集'
      }
      return text
    },
    /**
     * 是否显示已获得奖励组件
     */
    showHadReceiveReward() {
      return this.resCode == VIP_CALL_ERROR_CODE_ENUM.RELATION_HAD_RECEIVE
    },
    /**
     * 是否显示多个奖励组件
     */
    showBlessRewards() {
      return (
        this.rewardData
        && this.rewardData.length > 0
        && this.resCode == VIP_CALL_ERROR_CODE_ENUM.SUCCESS
      )
    },
    /**
     * 跳转小程序按钮是否有效
     */
    wxOpenLaunchWeappTagIsValid() {
      return wxOpenLaunchWeappTagIsValid()
    },
    /**
     * 显示跳转小程序标签
     */
    showWeappTag() {
      return this.isToWeApp && this.wxOpenLaunchWeappTagIsValid && !isWxProgram()
    },
    /**
     * 是否跳转小程序
     */
    isToWeApp() {
      // if (this.rewardData == null) {
      //   return false;
      // } else {
      //   if (this.rewardData.rewardType == REWARD_TYPE_ENUM.SCORE || this.rewardData.rewardType == REWARD_TYPE_ENUM.VIRTUAL_COIN) {
      //     // 单个奖励为积分或者虚拟云币
      //     return false;
      //   } else if (this.rewardData.length > 0) {
      //     let scoreDatas = this.rewardData.filter((item) => {
      //       return item.rewardType == REWARD_TYPE_ENUM.SCORE;
      //     });
      //     if (scoreDatas.length > 0) {
      //       // 多个奖励存在积分
      //       return false;
      //     }
      //   }
      // }
      // return true;
      return this.jumpType === JUMP_TYPE.MINIPROGRAM
    },
    /**
     * 获取微信小程序原始id
     */
    getWxAppId() {
      return wxConstData.yunjiWXAppOriginId
    },
    /**
     * 是否展示兑换优惠券模块
     */
    showCoupon() {
      return (
        this.rewardData && this.rewardData.rewardType == REWARD_TYPE_ENUM.SCORE
      )
    },
    /**
     * 微信小程序打开路径
     */
    weappPath() {
      // let subjectId =
      //   this.virtualCoinActivity && this.virtualCoinActivity.subjectId;
      // return this.rewardData &&
      //   this.rewardData.rewardType == REWARD_TYPE_ENUM.VIRTUAL_COIN
      //   ? `pages/index/subject.html?subjectId=${subjectId}`
      //   : "pages/index/index.html";
      return this.jumpContent
    },
    /**
     * 获得奖励类别，单个奖励同REWARD_TYPE_ENUM
     */
    rewardCategory() {
      if (this.rewardData) {
        if (this.rewardData.length) {
          return REWARD_CATEGORY.COMBINE_PRIZE
        } 
        return this.rewardData.rewardType
      }
    },
    /**
     * 点击按钮跳转类型
     */
    jumpType() {
      let type = ''
      const bagBasicInfor = this.bagBasicInfor || {}
      if (this.resCode === VIP_CALL_ERROR_CODE_ENUM.RELATION_HAD_RECEIVE) {
        type = bagBasicInfor.showButtonJumpType
      } else {
        switch (this.rewardCategory) {
          case REWARD_CATEGORY.SCORE:
            type = bagBasicInfor.scoreButtonJumpType
            break
          case REWARD_CATEGORY.COUPON:
            type = bagBasicInfor.couponButtonJumpType
            break
          case REWARD_CATEGORY.COIN:
            type = bagBasicInfor.coinButtonJumpType
            break
          case REWARD_CATEGORY.VIRTUAL_COIN:
            type = bagBasicInfor.coinVirtualButtonJumpType
            break
          case REWARD_CATEGORY.COMBINE_PRIZE:
            type = bagBasicInfor.combineButtonJumpType
            break
        }
      }
      return type
    },
    /**
     * 跳转内容
     */
    jumpContent() {
      let content = ''
      const bagBasicInfor = this.bagBasicInfor || {}
      if (this.resCode === VIP_CALL_ERROR_CODE_ENUM.RELATION_HAD_RECEIVE) {
        content = bagBasicInfor.showButtonJumpContent
      } else {
        switch (this.rewardCategory) {
          case REWARD_CATEGORY.SCORE:
            content = bagBasicInfor.scoreButtonJumpContent
            break
          case REWARD_CATEGORY.COUPON:
            content = bagBasicInfor.couponButtonJumpContent
            break
          case REWARD_CATEGORY.COIN:
            content = bagBasicInfor.coinButtonJumpContent
            break
          case REWARD_CATEGORY.VIRTUAL_COIN:
            content = bagBasicInfor.coinVirtualButtonJumpContent
            break
          case REWARD_CATEGORY.COMBINE_PRIZE:
            content = bagBasicInfor.combineButtonJumpContent
            break
        }
      }
      return content
    }
  },
  watch: {
    tick() {
      console.log('@xts->tick: ', this.tick)
    },
    showShareBtn() {
      if (this.showShareBtn) {
        // “我要发福袋”按钮曝光
        thinkingReport.track('exposure', {
          point_id: '27317',
          page_id: '80740',
          content_id: this.luckBagCode,
          sms_id: this.smsId
        })
      }
    }
  },
  components: {
    blessReward,
    blessRewards,
    itemList,
    moreBuyMoreReward,
    coupon,
    shareAlert: () => import('./shareAlert'),
    appletQrcode: () => import('./appletQRCode'),
    hadReceiveReward,
    guideDownloadApp
  },
  mounted() {
    this.getSwichs()
    this.queryRelationActivitySecondSharingSwitch()
    this.getFingerprintTick()
  },
  methods: {
    onLoad() {
      // debugger
      this.getItemList()
    },
    closeGuideDownloadAppDialog(value) {
      this.guideDownloadDialogShow = value
    },
    /**
     * 获取指纹设备tick
     */
    getFingerprintTick() {
      createTicketByMj().then((res) => {
        this.tick = res.tick || ''
      })
    },
    handleClickFn() {
      console.log('跳转小程序组件点击成功  success')
    },
    handleLaunchFn() {
      console.log('跳转小程序组件跳转成功  success')
      thinkingReport.track('others', {
        point_id: '25551',
        page_id: '80586',
        content_id: this.luckBagCode,
        sms_id: this.smsId
      })
      if (this.rewardData.rewardType === REWARD_TYPE_ENUM.VIRTUAL_COIN) {
        // 福袋奖品页-点击赚取更多云币
        thinkingReport.track('others', {
          point_id: '27094',
          page_id: '80740',
          content_id: this.luckBagCode,
          sms_id: this.smsId
        })
      }
      // eslint-disable-next-line no-unused-expressions
      // document.getElementById('launchBox') && document.getElementById('launchBox').remove()
    },
    handleErrorFn(e) {
      console.log('跳转小程序组件跳转失败 fail', e.detail)
      this.toSee()
      // this.canUseWeapp = false
      // eslint-disable-next-line no-unused-expressions
      // document.getElementById('launchBox') && document.getElementById('launchBox').remove()
    },
    /**
     * 获取福袋分享开关
     */
    queryRelationActivitySecondSharingSwitch() {
      queryRelationActivitySecondSharingSwitch({
        shopId: this.shopId,
        appCont: this.appCont,
        isFromHeJi: this.isFromHeJi
      }).then((res) => {
        if (res.code == 0 && res.data == 1) {
          this.isShowShareBtn = true
        }
      })
    },
    /**
     * 获取福袋活动开关
     */
    getSwichs() {
      getSwich({ shopId: this.shopId, appCont: this.appCont }).then((res) => {
        if (res.code == 0) {
          this.swichTag = res.data
          if (this.swichTag === 0) {
            this.resCode = VIP_CALL_ERROR_CODE_ENUM.RELATION_ACTIVITY_CLOSE
            this.openAndGetItemList()
          }
        }
      })
    },
    showShareBlessGuide() {
      this.shareGuideType = 2
      this.showShareAlert = true
      // "我也要发福袋"按钮点击
      thinkingReport.track('others', {
        point_id: '27318',
        page_id: '80740',
        content_id: this.luckBagCode,
        sms_id: this.smsId
      })
    },
    openBlessPackage() {
      if (this.needLogin) {
        bus.$emit('SHOW_LOGIN', true)
        return
      }
      if (!this.hasPhone) {
        bus.$emit('SHOW_REGISTER_ALIERT', true)
        return
      }
      
      thinkingReport.track('others', {
        point_id: this.isFromHeJi ? '26470' : '25550',
        page_id: '80586',
        content_id: this.luckBagCode,
        sms_id: this.smsId
      })
      // 拆福袋-立即打开
      thinkingReport.track('page_load', {
        point_id: '27018',
        page_id: '80740',
        content_id: this.luckBagCode,
        sms_id: this.smsId
      })
      Indicator.open({
        text: '加载中...',
        spinnerType: 'fading-circle'
      })
      const params = {
        shopId: this.shopId,
        appCont: this.appCont,
        luckBagCode: this.luckBagCode,
        channelType: this.isFromHeJi ? 1 : 0,
        consumerId: 13072,
        strategyTicket: this.tick,
        strategyAppVersion: '1' // 随便传
      }
      if (this.activityId && this.isFromHeJi) {
        params.activityId = this.activityId
      }
      remarkReward(params).then((res) => {
        // res = {
        //   code: 0,
        //   data: {
        //     receiveConsumerId: 13511111,
        //     receivePhone: '15988151552',
        //     receiveRelationRewards: [{
        //       detail: '{"endTime":1636300800000,"fullcouponId":104644,"fullcouponType":0,"maxHave":1,"maxNum":10000,"name":"test101403","scopeName":"全场通用","sendEndTime":1636214400000,"sendStartTime":1636041600000,"shopScope":0,"startTime":1636128000000,"status":2,"stock":9999,"useScope":0,"useValue":100,"value":10}', pictureUrl: 'https://static.yunjiglobal.com/qnUpload/frontend/recall/recallCoupon-1.png', rewardContent: '104644', rewardType: 1, rewardValue: 10, storeId: 3403 
        //     }],
        //     shareConsumerId: 13019906,
        //     virtualCoinActivity: null 
        //   },
        //   msg: '请求成功' 
        // }
        Indicator.close()
        const data = res.data || {}
        // res.errorCode = res.code = VIP_CALL_ERROR_CODE_ENUM.SUCCESS;
        const code = res.errorCode || res.code
        if (code === VIP_CALL_ERROR_CODE_ENUM.SUCCESS) {
          // 福袋奖品页
          thinkingReport.track('page_load', {
            point_id: '27093',
            page_id: '80740',
            content_id: this.luckBagCode,
            sms_id: this.smsId
          })
        } else if (code === VIP_CALL_ERROR_CODE_ENUM.RELATION_ACTIVITY_CLOSE || code === VIP_CALL_ERROR_CODE_ENUM.RELATION_LUCK_BAG_INVALIDATE) {
          // 加载-活动结束页
          thinkingReport.track('page_load', {
            point_id: '27315',
            page_id: '80740',
            content_id: this.luckBagCode,
            sms_id: this.smsId
          })
        }
        if (code === VIP_CALL_ERROR_CODE_ENUM.RELATION_REWARD_SELF) {
          // 自己点自己的分享
          this.shareGuideType = 1
          this.showShareAlert = true
        } else if (
          code === VIP_CALL_ERROR_CODE_ENUM.SUCCESS
          || code === VIP_CALL_ERROR_CODE_ENUM.RELATION_REWARD_HIT
          || code === VIP_CALL_ERROR_CODE_ENUM.RELATION_ACTIVITY_CLOSE
          || code === VIP_CALL_ERROR_CODE_ENUM.RELATION_HAD_RECEIVE
          || code === VIP_CALL_ERROR_CODE_ENUM.RELATION_HAD_RECEIVE_TODAY
          || code === VIP_CALL_ERROR_CODE_ENUM.RELATION_HAD_HIT
          || code === VIP_CALL_ERROR_CODE_ENUM.RELATION_LUCK_BAG_INVALIDATE
        ) {
          this.resCode = code
          if (
            code === VIP_CALL_ERROR_CODE_ENUM.SUCCESS
            || code === VIP_CALL_ERROR_CODE_ENUM.RELATION_HAD_RECEIVE
          ) {
            const receiveRelationRewards = data.receiveRelationRewards || []
            receiveRelationRewards.forEach((item) => {
              if (
                item.rewardType == REWARD_TYPE_ENUM.COIN
                || item.rewardType == REWARD_TYPE_ENUM.VIRTUAL_COIN
              ) {
                // 云币和虚拟云币默认单位是分，换算成元
                item.rewardValue /= 100
              } else if (item.rewardType == REWARD_TYPE_ENUM.COUPON) {
                // 优惠券解析详情字符串
                let detail = {}
                try {
                  detail = JSON.parse(item.detail)
                } catch (e) {
                  console.error('xts->blessPackage openBlessPackage ', e)
                }
                item.detail = detail
              }
            })
            this.receivePhone = data.receivePhone || ''
            this.virtualCoinActivity = data.virtualCoinActivity || {}
            if (receiveRelationRewards.length === 1) {
              this.rewardData = receiveRelationRewards[0] || {}
            } else {
              this.rewardData = receiveRelationRewards
            }
          }
          // 打开福袋
          this.openAndGetItemList()
        } else {
          Toast(res.errorMessage || res.msg)
        }
        // this.rewardData = [
        //   //   {
        //   //   detail: {
        //   //     endTime: 1580461714000,
        //   //     fullcouponId: 100757,
        //   //     fullcouponType: 0,
        //   //     maxHave: 5,
        //   //     maxNum: 10000000,
        //   //     name: "【摇福气】皮皮狗福玛玛品牌券",
        //   //     sendEndTime: 1579943295000,
        //   //     sendStartTime: 1579425117000,
        //   //     startTime: 1579425332000,
        //   //     status: 2,
        //   //     stock: 9999990,
        //   //     useScope: 0,
        //   //     useValue: 80,
        //   //     value: 19,
        //   //   },
        //   //   pictureUrl:
        //   //     "https://static.yunjiglobal.com/qnUpload/frontend/recall/recallCoupon-1.png",
        //   //   rewardContent: "100757",
        //   //   rewardType: 1,
        //   //   rewardValue: 100,
        //   //   storeId: 3306,
        //   // },
        //   {
        //     pictureUrl:
        //       "https://static.yunjiglobal.com/qnUpload/frontend/recall/recallCoupon-1.png",
        //     rewardContent: "100757",
        //     rewardType: 0,
        //     rewardValue: 100,
        //     storeId: '',
        //   },
        //   {
        //     pictureUrl:
        //       "https://static.yunjiglobal.com/qnUpload/frontend/recall/recallCoupon-1.png",
        //     rewardContent: "100757",
        //     rewardType: 2,
        //     rewardValue: 100,
        //     storeId: 3308,
        //   },
        // ];

        // (this.rewardData = {
        //   detail: {
        //     endTime: 1580461714000,
        //     fullcouponId: 100757,
        //     fullcouponType: 0,
        //     maxHave: 5,
        //     maxNum: 10000000,
        //     name: "【摇福气】皮皮狗福玛玛品牌券",
        //     sendEndTime: 1579943295000,
        //     sendStartTime: 1579425117000,
        //     startTime: 1579425332000,
        //     status: 2,
        //     stock: 9999990,
        //     useScope: 0,
        //     useValue: 80,
        //     value: 19,
        //   },
        //   pictureUrl:
        //     "https://static.yunjiglobal.com/qnUpload/frontend/recall/recallCoupon-1.png",
        //   rewardContent: "100757",
        //   rewardType: 1,
        //   rewardValue: 100,
        //   storeId: 3306,
        // }),
        //   (this.virtualCoinActivity = {
        //     exchangeTime: "1606449268962",
        //     subjectId: "1",
        //   });
        // this.rewardData = this.rewardData.concat(
        //   this.rewardData,
        //   this.rewardData,
        //   this.rewardData
        // );
        // this.openAndGetItemList();
      })
    },
    /**
     * 根据不同的奖励获取推荐信息
     */
    openAndGetItemList() {
      this.isShowBless = false
      
      this.$emit('openBlessPackage')
      this.getItemList()
    },
    /**
     * 获取奖励关联的storeId
     */
    getStoreId() {
      if (this.rewardData == null) {
        return ''
      }
      if (this.rewardData.length > 0) {
        for (let i = 0, len = this.rewardData.length; i < len; i++) {
          const item = this.rewardData[i]
          if (item.storeId) {
            return item.storeId
          }
        }
      }
      return this.rewardData.storeId || ''
    },
    /**
     * 获取商品标签
     */
    queryItemListMarks(list1, list2) {
      const itemIds1 = list1.map(item => item.itemId)
      const params1 = {
        templateId: 9,
        itemIds: itemIds1.join(',')
      }
      queryItemListMarks(params1).then((res) => {
        const code = res.errorCode
        if (code === 0) {
          this.labelList1 = this.labelList1.concat(res.data || [])
        }
      })

      const itemIds2 = list2.map(item => item.itemId)
      const params2 = {
        templateId: 9,
        itemIds: itemIds2.join(',')
      }
      queryItemListMarks(params2).then((res) => {
        const code = res.errorCode
        if (code === 0) {
          this.labelList2 = this.labelList2.concat(res.data || [])
        }
      })
    },
    /**
     * 请求推荐商品列表
     */
    getItemList() {
      const storeId = this.getStoreId()
      console.log('storeId:', storeId)
      if (!storeId) {
        return
      }
      const params = {
        storeId,
        pageIndex: this.pageIndex,
        pageSize: 10
        // storeId: 3306, // 测试storeIdid
        // getIntelligentItemList({
        // appCont: this.appCont,
        // type: this.rewardData.rewardType === 1 ? 1 : 0,
      }
      intelligentItem(params).then((res) => {
        const code = res.errorCode || res.code
        if (code === 0) {
          const oldList = res.data || []
          const itemId = oldList.map(item => item.itemId).join(',')
          // 曝光埋点
          thinkingReport.track('exposure', {
            point_id: '29037',
            page_id: '81023',
            item_id: itemId,
            content_name: +this.appCont === 7 ? '小程序' : 'h5'
          })

          if (!oldList.length) {
            this.finished = true
          } else {
            this.finished = false
          }
          this.loading = false
          // 奇数
          const list1 = oldList.filter((item, index) => index % 2 === 0)
          // 偶数
          const list2 = oldList.filter((item, index) => index % 2 !== 0)

          this.itemList1 = this.itemList1.concat(list1) 
          this.itemList2 = this.itemList2.concat(list2) 
          console.log(this.itemList1)
          console.log(this.itemList2)
          
          this.pageIndex = this.pageIndex + 1
          this.queryItemListMarks(list1, list2)
        }
      })
    },
    toSee() {
      const ids = exposureThinkingReport()
      window.thinkingReport.track('exposure', {
        page_id: '81023',
        point_id: '29038',
        item_id: ids.join(','),
        content_name: +this.appCont === 7 ? '小程序' : 'h5',
        point_name: '离开曝光'
      })
      // thinkingReport.track("others", {
      //   point_id: "25551",
      //   page_id: "80586",
      // });
      // if (this.rewardData.rewardType === REWARD_TYPE_ENUM.VIRTUAL_COIN) {
      //   // 福袋奖品页-点击赚取更多云币
      //   thinkingReport.track("others", {
      //     point_id: "27094",
      //     page_id: "80740",
      //   });
      //   this.gotoSubject()
      // }else if (this.isToWeApp) {
      //   this.showMiniProgramCodeImage();
      // } else {
      //   // 去应用市场
      //   this.gotoAppMarket();
      // }
      // if (this.rewardData.rewardType === REWARD_TYPE_ENUM.VIRTUAL_COIN) {
      //   // 福袋奖品页-点击赚取更多云币
      //   thinkingReport.track("others", {
      //     point_id: "27094",
      //     page_id: "80740",
      //   });
      // }
      // let subjectId =
      //   this.virtualCoinActivity && this.virtualCoinActivity.subjectId;
      // this.gotoSubject(subjectId)

      if (this.rewardData && this.rewardData.rewardType === REWARD_TYPE_ENUM.VIRTUAL_COIN) {
        // 福袋奖品页-点击赚取更多云币
        thinkingReport.track('others', {
          point_id: '27094',
          page_id: '80740',
          content_id: this.luckBagCode,
          sms_id: this.smsId
        })
      }

      if (this.resCode === VIP_CALL_ERROR_CODE_ENUM.RELATION_ACTIVITY_CLOSE || this.resCode === VIP_CALL_ERROR_CODE_ENUM.RELATION_LUCK_BAG_INVALIDATE) {
        thinkingReport.track('others', {
          point_id: '27316',
          page_id: '80740',
          content_id: this.luckBagCode,
          sms_id: this.smsId
        })
      }

      switch (this.jumpType) {
        case JUMP_TYPE.APP:
          this.gotoAppMarket()
          break
        case JUMP_TYPE.MINIPROGRAM:
          this.gotoMiniprogram()
          break
        case JUMP_TYPE.SUBJECT:
          this.gotoSubject()
          break
        case JUMP_TYPE.H5:
          window.location.href = this.jumpContent
          break
        default: 
          this.gotoAppMarket()
      }
    },
    gotoMiniprogram() {
      if (isWxProgram()) {
        // 小程序内
        forwardTo({
          url: `/${this.jumpContent}`
        })
      } else {
        this.showMiniProgramCodeImage()
      }
    },
    /**
     * 展示小程序二维码
     */
    showMiniProgramCodeImage() {
      // 跳转小程序，生成微信小程序二维码
      if (this.qrcodeImage) {
        // 已存在二维码
        this.showApplet = true
        return
      }
      Indicator.open({
        text: '加载中...',
        spinnerType: 'fading-circle'
      })
      getMiniProgramQrCode({
        appCont: this.appCont,
        scene: `shopId=${this.shopId}`,
        wxLoginChannel: 'discoverLive_miniprogram'
      }).then(
        (res) => {
          Indicator.close()
          if ((res.code === 0 || res.errorCode === 0) && res.data) {
            this.showApplet = true
            this.qrcodeImage = res.data
          } else {
            // 请求不到小程序码，去应用市场
            this.gotoAppMarket()
          }
        },
        () => {
          // 请求错误，去应用市场
          this.gotoAppMarket()
        }
      )
    },
    /**
     * 跳转专题
     */
    gotoSubject() {
      // if(subjectId){
      //   window.location.href = `//${globalConfig.yunjibuyerPath}/yj/subject?subjectId=${subjectId}&shopId=${this.shopId}&appCont=${this.appCont}`;
      // } else {
      //   window.location.href = `//${globalConfig.yunjibuyerPath}/yjbuyer/more?shopId=${this.shopId}&appCont=${this.appCont}`;
      // }
      if (isWxProgram()) {
        forwardTo({ url: `/pages/subject/subject?&shopId=${this.shopId}&appCont=7&origin=1&subjectId=${this.jumpContent}` })
      } else {
        window.location.href = `//${globalConfig.yunjibuyerPath}/yj/subject?subjectId=${this.jumpContent}&shopId=${this.shopId}&appCont=${this.appCont}`
      }
    },
    /**
     * 去应用市场
     */
    gotoAppMarket() {
      if (isWxProgram()) {
        this.guideDownloadDialogShow = true
        return
      }

      const { hostname } = window.location
      const y = hostname.split('.')[0]
      const userPath = y === 'spe' ? 'm.yunjiglobal.com' : 't-do-dev.yunjiglobal.com' // 拉起app的现网域名就是m.yunjiglobal.com
      const targetUrl = 'yunji://memberCenter'
      window.location.href = `
      ${window.location.protocol}//${userPath}/yjbuyer/seller-link?shopId=${
  this.shopId
}&goType=callAppWebUrl&openUrl=${encodeURIComponent(targetUrl)}`
    }
  }
}
</script>
<style>
.wx-open-launch-weapp {
  width: 100%;
  height: 100%;
  display: block;
}
</style>
<style lang="less" scoped>
.bless-package {
  width: 100%;
  .not-open-status {
    // position: absolute;
    left: 0;
    top: 3.98rem;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;

    .preview-package {
      width: 79%;
      img {
        display: block;
        width: 100%;
      }
    }
    .tip {
      margin-top: 0.36rem;
      width: 100%;
      text-align: center;
      font-size: 0.32rem;
      height: 0.44rem;
      line-height: 0.44rem;
      color: #fffab4;
      font-weight: bold;
    }
    .open-now {
      margin-top: 0.4rem;
      width: 77%;
      img {
        display: block;
        width: 100%;
      }
    }
  }
  .bless-bottom {
    width: 100%;
    // display: flex;
    // flex-direction: column;
    // align-items: center;
    .bless-img {
      margin-top: 0.4rem;
      width: 100%;
    }
    .account {
      margin-top: 0.2rem;
      color: #fffab4;
      font-size: 0.32rem;
      text-align: center;
      line-height: 0.44rem;
      height: 0.44rem;
      font-weight: bold;
    }
    .to-see {
      position: fixed;
      bottom: 0;
      width: 100%;
      height: 1.5rem;
      // background-image: linear-gradient(
      //   180deg,
      //   rgba(255, 68, 78, 0) 0%,
      //   #ff444e 50%
      // );
      z-index: 100;
      .to-see-bg {
        display: block;
        margin: 0rem auto;
        width: 94%;
        position: relative;
        z-index: 101;
      }
      .to-see-btn {
        margin: 0rem auto;
        width: 6.7rem;
        height: 1rem;
        line-height: 1rem;
        position: absolute;
        top: 0.1rem;
        left: 50%;
        transform: translateX(-50%);
        font-size: 0.4rem;
        color: #dc0000;
        letter-spacing: 0;
        text-align: center;
        z-index: 102;
        span {
          position: relative;
          font-weight: bold;
          img {
            position: absolute;
            top: 0.01rem;
            width: 0.42rem;
            height: 0.51rem;
          }
        }
      }
    }
    .to-weapp {
      z-index: 101;
    }
  }
  .float-share {
    position: fixed;
    top: 0.4rem;
    right: 0.3rem;
    width: 1.8rem;
    img {
      display: block;
      width: 100%;
    }
  }

  .bless-leave {
    opacity: 1;
  }
  .bless-leave-to {
    opacity: 0;
  }
  .bless-leave-active {
    transition: all 1s;
  }
  .reward-enter {
    opacity: 0;
  }
  .reward-enter-to {
    opacity: 1;
  }
  .reward-enter-active {
    transition: all 1s;
  }
}
</style>
